import React from 'react'

import './Lists.scss'

export const OrderedList = ({  children, type = 'A' }) => (
    <ol className='orderedList' type={type}>
        {children}
    </ol>
)

export const UnorderedList = ({  children }) => (
    <ul className='unorderedList'>
        {children}
    </ul>
)

export const ListItem = ({ children }) => (
    <li>{children}</li>
)


// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/Lists/Lists.jsx